import { lazy } from "react";
import { RouteConfig } from "../../types/RouteConfig";

export const maintenanceRoute: RouteConfig<'with-page'> = {
    name: 'Maintenance',
    path: '/maintenance',
    icon: 'mdi mdi-home-variant-outline',
    page: lazy(() => import('.')),
    flags: ['no-menu-item', 'remove-menu']
}